import React, {
    Component
} from 'react';

class BestManager extends Component {
    render() {
        return <div>

        </div>
    }
}

export default BestManager;


// WEBPACK FOOTER //
// ./src/components/home/cards/BestManager.js